// Central company details. Update these values to change them site-wide.
export const COMPANY = {
  name: 'Quick Credit',
  legalName: 'Quick Credit Financial Services, Inc.',
  addressLine1: '350 Mission Street, Suite 200',
  addressLine2: 'San Francisco, CA 94105',
  country: 'United States',
  phone: '(917) 983-2016',
  phoneHref: 'tel:+19179832016',
  email: 'support@quickcredit.com',
  website: 'https://quickcredit.live',
  hours: [
    { days: 'Monday – Friday', time: '9:00 AM – 6:00 PM PT' },
    { days: 'Saturday', time: '10:00 AM – 4:00 PM PT' },
    { days: 'Sunday', time: 'Closed' },
  ],
} as const;

export const LOAN_TERMS = {
  minAmount: 1000,
  maxAmount: 50000,
  minTermMonths: 12,
  maxTermMonths: 60,
  minApr: 5.96,
  maxApr: 35.99,
  repApr: 18.9,
  originationFeeMin: 0,
  originationFeeMax: 8,
  lateFee: 15,
} as const;
